const DEFAULT_OPTIONS = {
	startValue: 0.0,
	endValue: 1.0,
	easeFunc: a => a * a * a,
	duration: 400
};

export default class Animation {
	constructor(func, durationOrOptions) {
		const options = Object.assign({}, DEFAULT_OPTIONS);

		if (typeof durationOrOptions === 'object') {
			Object.assign(options, durationOrOptions);
		} else if (durationOrOptions) {
			options.duration = durationOrOptions;
		}

		options.func = func;
		Object.assign(this, options);
		this.running = false;
	}

	start() {
		if (process.env.NODE_ENV !== 'production') {
			if (typeof this.func !== 'function') {
				throw new Error('Animation: func is not a function');
			}

			if (this.running) {
				throw new Error('Animation: Already started');
			}
		}

		const diff = this.endValue - this.startValue;
		let startTime = null;

		const anim = (curTime) => {
			if (!this.running) {
				return;
			}

			if (startTime === null) {
				startTime = curTime;
			}

			let b = (curTime - startTime) / this.duration;
			if (b > 1.0) {
				b = 1.0;
			}

			this.func(this.startValue + diff * this.easeFunc(b));

			if (b !== 1.0) {
				window.requestAnimationFrame(anim);
			} else {
				this.stop();
			}
		};

		this.running = true;
		window.requestAnimationFrame(anim);
	}

	stop() {
		if (!this.running) {
			return;
		}

		this.running = false;

		if (typeof this.callback === 'function') {
			this.callback();
		}
	}
}
